import React, { useState, useEffect, useCallback } from 'react'
import { Link, useLocation, matchPath } from 'react-router-dom'
import useStore from '../../store'
import './Menu.css'

const Menu = () => {
  const location = useLocation()
  const [disabled, setDisabled] = useState(false)
  const [linkTo, setLinkTo] = useState('/artists')
  const [hovered, setHovered] = useState(false)
  const playByName = useStore((state) => state.playByName)

  useEffect(() => {
    const match = matchPath(
      location.pathname,
      { path: '(/|/artists|/info)?', exact: true },
    )

    const hasMatch = Boolean(match)
    setDisabled(!hasMatch)

    setLinkTo(location.pathname === '/' ? '/artists' : '/')
  }, [location])

  const onMouseOver = useCallback(() => {
    setHovered(true)
    playByName('Menu', 'hover')
  }, [playByName])

  const onClick = useCallback(() => {
    setHovered(false)
    playByName('Menu', 'click')
  }, [playByName])

  let vh = window.innerHeight * 0.01

  if (disabled) return null
  return (
    <div className="g-marquee">
      <Link
        to={linkTo}
        onMouseOver={onMouseOver}
        onMouseOut={() => setHovered(false)}
        onClick={onClick}
      >
        <h1 className="marquee top">
          <span className="part one">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
          <span className="part two">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
        </h1>
  
        <h1 className="marquee bottom">
          <span className="part one">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
          <span className="part two">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
        </h1>
  
        <h1 className="marquee left" style={{ '--vh': `${vh}px` }}>
          <span className="part one">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
          <span className="part two">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
        </h1>
  
        <h1 className="marquee right" style={{ '--vh': `${vh}px` }}>
          <span className="part one">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
          <span className="part two">GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;GENESYS→2021 &nbsp;&nbsp;&nbsp;</span>
        </h1>
      </Link>

      {hovered && (
        <div className="g-logo-hover">
          <img
            alt="Genesys 2021"
            src="/assets/images/menu/Genesys_MenuHover.png"
          />
        </div>
      )}
    </div>
  )
}

export default Menu
